import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../../../config';
import common from './../../../common';
import { Scrollbars } from 'react-custom-scrollbars';
import OutsideNotifier from '../../../OutsideNotifier';
import {
    toggleSortByPlayerList,
    applySortByBoth
} from './../../../actions/FilterActions';

class ListHeader extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.skill && (this.props.skill !== prevProps.skill)) {
            const elem = this._header;
            elem.classList.add('si-skill-changed');
            setTimeout(() => {
                elem.classList.remove('si-skill-changed');
            }, 300);
        }
    }

    getLastSkill = (highlightedSkill) => {
        const thisHighlightedSkill = highlightedSkill || {};
        // const skill = thisHighlightedSkill.skill ? thisHighlightedSkill.skill : config.EnumPosition.Forwards;
        const skill = thisHighlightedSkill.skill;
        const lastSkill = common.getLocalStorage('lastSkill');
        return (skill || lastSkill);
    };

    onSortOpen = () => {
        if (this.props.playerRecomendedSelectedKey == config.playerRecomendationDefault) {
            if (!this.props.showPlayerSortPopFlag) {
                let pageName = "";
                if (window.location.pathname.indexOf("/manage-team")) {
                    pageName = "/uclfantasy/my-team/transfers/"
                } else {
                    pageName = "/uclfantasy/create-team/"
                }
                common.customTracking('Sort By - Player List', pageName);
            }
            this.props.toggleSortByPlayerList();
        } else {

        }

    };

    onSortApply = (sortOption) => {

        this.props.applySortByBoth(sortOption);
        common.customTracking('Select Sort By filter -' + config.sortByArrTracking[sortOption], common.getPageName());
        this.props.toggleSortByPlayerList();
    };

    render() {
        const lastSkill = this.getLastSkill(this.props.highlightedSkill);

        const className = common.makeClasses({
            'si-list-header': true,
            'si-flexBox': true,
            'si-cursor-pointer': !this.props.showPlayerSortPopFlag,
            'si-disabled-sort': this.props.playerRecomendedSelectedKey != config.playerRecomendationDefault

        })
        return <div className={ className } ref={ (ref) => this._header = ref } onClick={ () => this.onSortOpen() } style={ this.props.showPlayerSortPopFlag ? { 'zIndex': 111 } : {} }>
            <span>{/*this.props.trans[lastSkill]*/ }</span>
            <span className="si-total-pts">{ this.props.trans[this.props.sortBy] }
                <i className="icon-ucl-back_arrow" /></span>
            { this.props.showPlayerSortPopFlag ? <OutsideNotifier handler={ () => this.onSortOpen() }> <ul className="si-dropdown-options">
                <Scrollbars autoHide>
                    { this.props.sortByArr.map((el) => {
                        const className = common.makeClasses({
                            'si-active': el === this.props.sortBy
                        });
                        return <li
                            className={ className }
                            key={ el }
                            onClick={ () => this.onSortApply(el) }>{ this.props.trans[el] ? this.props.trans[el] : el }</li>
                    }) }
                </Scrollbars>
            </ul> </OutsideNotifier> : null }
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        highlightedSkill: state.formationData.teamData.highlightedSkill,
        sortBy: state.formationData.playerFilters.sortBy,
        sortByArr: state.formationData.sortByArr,
        showPlayerSortPopFlag: state.formationData.showPlayerSortPopFlag,
        playerRecomendedSelectedKey: state.formationData.playerRecomendedSelectedKey
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleSortByPlayerList: () => dispatch(toggleSortByPlayerList()),
        applySortByBoth: (sortOption) => dispatch(applySortByBoth(sortOption)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ListHeader);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/ListHeader.js